<template>
  <div class="product-markers" v-if="list.length">
    <div
      v-for="(m, i) in list"
      :key="i"
      :class="`product-markers-${m.type}`"
      :style="m.styles"
    >
      {{ m.text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-markers',

  props: {
    markers: {
      type: Array,
      default: () => [],
    },
    plates: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 10,
    }
  },

  computed: {
    list() {
      return [
        ...this.plates.map(p => ({
          text: p.title,
          type: p.type,
          styles: {
            backgroundColor: p?.backgroundColor,
            color: p?.fontColor
          }
        })),
        ...this.markers.map(m => {
          switch (m) {
            case 'NEW':
              return {
                text: 'NEW',
                type: 'marker',
                styles: {
                  backgroundColor: '#0099A8',
                  color: '#fff'
                }
              }
            case 'BESTPRICE':
              return {
                text: 'ЛУЧШАЯ ЦЕНА',
                type: 'marker',
                styles: {
                  backgroundColor: '#F34744',
                  color: '#fff'
                }
              }
            case 'RECOMMEND':
              return {
                text: 'ХИТ ПРОДАЖ',
                type: 'marker',
                styles: {
                  backgroundColor: '#FFB71B',
                  color: '#fff'
                }
              }
            case 'BONUSNA':
              return {
                text: 'БЕЗ БОНУСОВ',
                type: 'marker',
                styles: {
                  backgroundColor: '#333333',
                  color: '#fff'
                }
              }
            default:
              return {}
          }
        })
      ]
        .filter(m => m.text) // на всякий случай, вдруг кто пустой
        .splice(0, this.limit)
      ;
    },
  },
}
</script>

<style lang="scss">
.product-markers {
  display: flex;
  flex-wrap: wrap;
  margin: -3px;
  > div {
    padding: 0 4px;
    color: #fff;
    font-size: 10px;
    line-height: 16px;
    font-weight: bold;
    background-color: $black;
    border-radius: 4px;
    margin: 3px;
    white-space: nowrap;

    &.discount {
      background-color: $red;
    }
  }
}

@include breakpoint("desktop") {
  .product-markers {
    margin: -10px -8px;
    > div {
      padding: 4px 8px;
      font-size: 12px;
      line-height: 16px;
      margin: 5px 4px;
    }
  }
}
</style>